import { render, staticRenderFns } from "./DocsMenu.vue?vue&type=template&id=d089c010&"
import script from "./DocsMenu.vue?vue&type=script&lang=js&"
export * from "./DocsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports